
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({
  components: {},
  filters,
})
export default class MyCourseContent extends Vue {
  @Action("setContent", { namespace: "myCourse" })
  private setContent: any;

  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: [] })
  private contents!: Array<any>;

  @Watch("step")
  private onTrigger() {
    if (this.isLastStep) {
      this.$emit("next");
    }
    this.track();
  }

  private time = 0;

  private get content() {
    return this.contents[this.step - 1];
  }
  private get extension() {
    return this.content?.content
      .split(/[#?]/)[0]
      .split(".")
      .pop()
      .trim()
      .toLowerCase();
  }
  private get isVideo() {
    return ["mp4", "mkv", "mov", "avi"].includes(this.extension);
  }
  private get isPdf() {
    return ["pdf"].includes(this.extension);
  }
  private get isLastStep() {
    return this.step === this.maxSteps;
  }
  private get maxSteps() {
    return this.contents?.length;
  }

  private mounted() {
    this.track();
  }

  private youtubeParser(url) {
    let regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    let match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  }

  private prev() {
    if (this.step === 1) return;
    this.$emit("nextStep", this.step - 1);
  }

  private next() {
    this.$emit("nextStep", this.step + 1);
    // Emit refresh only when user goes to next content (content completed)
    this.$emit("refresh");
  }

  private track() {
    this.time = 0;
    if (this.isVideo) {
      setTimeout(() => {
        const video = document.getElementById(
          `content-video-${this.content?.id}`
        ) as any;
        if (video) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          video.ontimeupdate = () => {
            const currentTime = video.currentTime;
            if (currentTime - this.time >= 3) {
              this.time = currentTime;
              this.setContent({
                params: {
                  id: this.content?.id,
                  last_play: Math.floor(this.time),
                },
                // No refresh emit here
              });
            }
          };
          // Emit refresh only when video ends (content completed)
          video.onended = () => {
            this.$emit("refresh");
          };
        }
      }, 500);
    } else {
      this.setContent({
        params: {
          id: this.content?.id,
          last_play: 0,
        },
        // No refresh emit here
      });
    }
  }
}
